import { useRef, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import ButtonClose from "../../modules/homeout/principal/components/modal/ButtonClose";
import SidebarActivarCuentaCodigo from "./SidebarActivarCuentaCodigo";
import SidebarActivarCuentaDocumento from "./SidebarActivarCuentaDocumento";
import SidebarActivarCuentaPass from "./SidebarActivarCuentaPass";

const SidebarActivarCuenta = ({
  urlApi,
  codRecaptcha,
  show,
  setShow,
  setShowLogin,
  setShowModalActivaSuccess,
  setObjUsuarioLogin,
  setLoading,
}) => {
  const handleClose = () => {
    setShow(false);
    setMensaje("");
    setCount(1);
  };

  const [errorData, setErrorData] = useState(false);
  const [count, setCount] = useState(1);
  const [mensaje, setMensaje] = useState("");
  const [formCode, setFormCode] = useState({
    id: "",
    code: "",
    fono: "",
    tokenCaptcha: "",
  });

  const [form, setForm] = useState({
    identificacion: "",
    tokenCaptcha: "",
  });

  // RECAPTCHA
  const recaptchaRef = useRef();

  return (
    <>
      <Offcanvas show={show} onHide={handleClose} placement="end">
        <ButtonClose close={handleClose} />
        <Offcanvas.Body>
          {count === 1 && (
            <SidebarActivarCuentaDocumento
              errorData={errorData}
              mensaje={mensaje}
              recaptchaRef={recaptchaRef}
              setMensaje={setMensaje}
              setSpinner={setLoading}
              setErrorData={setErrorData}
              setFormCode={setFormCode}
              formCode={formCode}
              setCount={setCount}
              form={form}
              setForm={setForm}
              urlApi={urlApi}
              codRecaptcha={codRecaptcha}
              close={handleClose}
              setShowLogin={setShowLogin}
            />
          )}
          {count === 2 && (
            <SidebarActivarCuentaCodigo
              errorData={errorData}
              mensaje={mensaje}
              formCode={formCode}
              recaptchaRef={recaptchaRef}
              setMensaje={setMensaje}
              setSpinner={setLoading}
              form={form}
              setErrorData={setErrorData}
              setCount={setCount}
              setFormCode={setFormCode}
              urlApi={urlApi}
              codRecaptcha={codRecaptcha}
            />
          )}
          {count === 3 && (
            <SidebarActivarCuentaPass
              errorData={errorData}
              mensaje={mensaje}
              recaptchaRef={recaptchaRef}
              setMensaje={setMensaje}
              setSpinner={setLoading}
              setErrorData={setErrorData}
              formCode={formCode}
              setCount={setCount}
              urlApi={urlApi}
              codRecaptcha={codRecaptcha}
              handleClose={handleClose}
              setShowModalActivaSuccess={setShowModalActivaSuccess}
              form={form}
              setObjUsuarioLogin={setObjUsuarioLogin}
            />
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default SidebarActivarCuenta;
